<template>
  <b-modal
    id="product-edit-modal"
    ref="productWarning"
    :visible="isModalVisible"
    size="sm"
    modal-class="modal-primary custom-model"
    title="Confirmation"
    centered
    no-close-on-backdrop
    no-close-on-esc
    @ok="$emit('ok')"
    @hide="$emit('hide')"
  >
    <p>Are you sure you want to close? All unsaved changes will be lost.</p>
  </b-modal>
</template>
<script>

import { BModal } from 'bootstrap-vue'

export default {
  name: 'ConfirmationModal',
  components: {
    BModal,
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
